<form class="login-form" data-testid="login-form" (ngSubmit)="login()" [formGroup]="loginForm">
  <div class="login-form-title h6">Log In to Your Account</div>
  <div class="form-group">
    <label for="email" class="form-label">Email<span class="required">*</span></label>
    <input
      type="email"
      class="form-control"
      [ngClass]="{
        error:
          loginForm.get('email')?.invalid &&
          (loginForm.get('email')?.dirty || loginForm.get('email')?.touched),
      }"
      id="email"
      data-testid="login-email-input"
      placeholder="Enter your registered email address"
      formControlName="email"
      (focus)="emailError = ''"
    />
    <app-error-message
      testId="login-email-validation-error"
      *ngIf="
        loginForm.get('email')?.invalid &&
        (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)
      "
    >
      Please enter a valid email address.
    </app-error-message>
    <app-error-message testId="login-email-error-message" *ngIf="emailError">{{
      emailError
    }}</app-error-message>
  </div>
  <div class="form-group">
    <label for="password">Password<span class="required">*</span></label>
    <input
      type="password"
      id="password"
      data-testid="login-password-input"
      placeholder="Enter your password"
      [type]="showPassword ? 'text' : 'password'"
      formControlName="password"
      class="form-control"
      [ngClass]="{
        error:
          loginForm.get('password')?.invalid &&
          (loginForm.get('password')?.dirty || loginForm.get('password')?.touched),
      }"
      (focus)="passwordError = ''"
    />
    <img
      [src]="showPassword ? 'assets/images/eye.svg' : 'assets/images/eye-off.svg'"
      class="eye-icon"
      alt="Show Password"
      data-testid="login-password-visibility-toggle"
      (click)="togglePasswordVisibility()"
    />
    <app-error-message
      testId="login-password-validation-error"
      *ngIf="
        loginForm.get('password')?.invalid &&
        (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)
      "
    >
      Password required.
    </app-error-message>
    <app-error-message testId="login-password-error-message" *ngIf="passwordError">{{
      passwordError
    }}</app-error-message>
  </div>
  <app-captcha *ngIf="showCaptcha"></app-captcha>
  <div class="form-group-inline">
    <div class="checkbox-group">
      <input
        type="checkbox"
        id="remember"
        data-testid="login-remember-me-checkbox"
        formControlName="rememberMe"
        class="custom-checkbox"
      />
      <label class="p5" for="remember">Remember me</label>
    </div>
    <a
      routerLink="/forgot-password"
      class="forgot-password"
      data-testid="login-forgot-password-link"
      >Forgot password?</a
    >
  </div>
  <button
    type="submit"
    class="login-btn btn btn-primary btn-large"
    data-testid="login-button"
    [ngClass]="{ disabled: loginForm.invalid || isSubmitting }"
    [disabled]="loginForm.invalid || isSubmitting"
  >
    <span *ngIf="!isSubmitting">Log In</span>
    <span *ngIf="isSubmitting">Loading...</span>
  </button>
  <div class="privacy-note">
    <img src="/assets/images/Icon-lock.png" alt="Privacy" />
    <div>
      <div class="h10">Your privacy matters to us!</div>
      <p class="p7">
        We use industry-leading encryption and security measures to keep your information safe.
      </p>
    </div>
  </div>
</form>
